import * as React from 'react';
import { Admin, Resource } from 'react-admin';

import users from './admin/User';
import httpClient from './httpClient';
import crudProvider from './providers/crudProvider';
import authProvider from './providers/authProvider';
import { server } from './config/server';
import { MenuLayout } from './components/MenuLayout';
import transactionsV2 from './admin/transactions-v2';
import userCard from './admin/user-card';
import logs from './admin/log';
import geoGroup from './admin/geo-group';
import geolocation from './admin/geolocation';

const App = () => (
  <Admin
    layout={MenuLayout}
    authProvider={authProvider}
    dataProvider={crudProvider(server.apiUrl, httpClient)}
  >
    <Resource name="transactions-v2" {...transactionsV2} />
    <Resource name="users" {...users} />
    <Resource name="user-card" {...userCard} />
    <Resource name="geo-group" {...geoGroup} />
    <Resource name="geolocation" {...geolocation} />
    <Resource name="logs" {...logs} />
    <Resource name="users/list" />
    <Resource name="library/get-types-list" />
    <Resource name="library/get-account-list" />
    <Resource name="library/get-systems-list" />
    <Resource name="library/get-bin-list" />
    <Resource name="users/get-geolocation-by-user" />
  </Admin>
);

export default App;
